import moment from 'moment-timezone';

import { CALL_DURATION, SERVER_TIMEZONE } from '../constants';

export const getFormattedDateInMomentDefaultTZ = date => {
  const localOffset = date.getTimezoneOffset() * -1;
  const momentOffset = moment(date).utcOffset() * -1;

  return moment(date).add(localOffset + momentOffset, 'minute');
};

export const getNowInDefaultTimezoneAsDate = () => {
  const currentDate = moment().add(new Date().getTimezoneOffset(), 'minute');
  const year = currentDate.get('year');
  const month = currentDate.get('month');
  const day = currentDate.get('date');
  const hour = currentDate.get('hour');
  const minute = currentDate.get('minute');

  return new Date(Date.UTC(year, month, day, hour, minute, 0, 0));
};

export const getUTCOffsetInHoursAsString = timezone => {
  const utcOffsetInHours = moment().tz(timezone).utcOffset() / 60;

  if (utcOffsetInHours > 0) {
    return `+${utcOffsetInHours}`;
  }

  return `${utcOffsetInHours}`;
};

export const applyServerTimezone = date =>
  date.replace(/\.\d+Z$/, SERVER_TIMEZONE);

const padTime = v => v.toString().padStart(2, '0');

export const secondsToTime = sec => {
  const hours = Math.floor(sec / CALL_DURATION.SECONDS_IN_HOUR);
  const minutes = Math.floor(
    (sec % CALL_DURATION.SECONDS_IN_HOUR) / CALL_DURATION.SECONDS_IN_MINUTE,
  );
  const seconds = sec % CALL_DURATION.SECONDS_IN_MINUTE;

  return [padTime(hours), padTime(minutes), padTime(seconds)].join(':');
};
